import React, { useState, useEffect } from 'react'
import _ from 'underscore'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'

import Tabs, { Tab } from 'components/Tabs'

import SiteMessages from 'pages/SiteMessages/Messages'
import FeatureTours from 'pages/SiteMessages/FeatureTours'

import { PageTitle, SinglePanePage } from 'styles/shared'

const TABS = [
  { header: 'Site Messages', detailsComponent: SiteMessages },
  { header: 'Feature Tours', detailsComponent: FeatureTours }
]

const SiteMessageTabs = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const pathname = location.pathname

  const [activeTabIndex, setActiveTabIndex] = useState(0)

  useEffect(() => {
    if (pathname && pathname.includes('feature_tours')) {
      setActiveTabIndex(1)
    } else {
      setActiveTabIndex(0)
    }
  }, [pathname])

  const onTabChange = (index) => {
    setActiveTabIndex(index)
    if (index === 0) {
      navigate('/admin/site_messages')
    } else {
      navigate('/admin/feature_tours')
    }
  }

  return (
    <SinglePanePage>
      <PageTitle>Site Messages</PageTitle>
      <Tabs
        tabpage="site_message"
        activeTabIndex={activeTabIndex}
        onSelectTabIndexCallback={(index) => onTabChange(index)}
        tabItems={
          _.map(TABS, r => {
            const item: Tab = {
              key: r.header,
              header: <S.Header>{r.header}</S.Header>,
              details: <r.detailsComponent />
            }

            return item
          })
      }
      />
    </SinglePanePage>
  )
}

export default SiteMessageTabs

const S = {
  Header: styled.div`
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 10px;
`

}
